import camelcaseKeys from 'camelcase-keys';
import type { CamelCasedPropertiesDeep } from 'type-fest';

export type Camelized<T> = CamelCasedPropertiesDeep<T>;

export function camelize<T extends Record<string, unknown> | readonly unknown[]>(input: T): Camelized<T>;
export function camelize<T extends Record<string, unknown> | readonly unknown[]>(input: T | null | undefined): Camelized<T> | null | undefined;
export function camelize<T extends Record<string, unknown> | readonly unknown[]>(input: T | null | undefined): Camelized<T> | null | undefined {
  if (input == null) return input;
  return camelcaseKeys(input as never, { deep: true }) as Camelized<T>;
}
